module.exports = __webpack_public_path__ + "img/1440.017a4441.jpg";